const SQL_PROBE_PATTERNS = [
  /dbms_pipe\s*\.\s*receive_message/i,
  /pg_sleep\s*\(/i,
  /\bsleep\s*\(/i,
  /\bbenchmark\s*\(/i,
  /waitfor\s+delay/i,
  /\bxp_cmdshell\b/i,
  /\bsys\s*\.\s*fn_/i,
  /\b(?:union\s+(?:all\s+)?select|select[\s\S]+?\s+from|insert\s+into|update[\s\S]+?\s+set|delete\s+from|drop\s+(?:table|database|schema)|truncate\s+table|alter\s+table|exec(?:ute)?\s*\(|declare\s+@)\b/i,
  /['"`)]?\s*(?:or|and)\s+['"`]?\s*\d+\s*=\s*\d+/i,
  /['"`]\s*\(/i,
];

const normalize = (value) => {
  let normalized = String(value || "");
  for (let index = 0; index < 2; index += 1) {
    try {
      const decoded = decodeURIComponent(normalized);
      if (decoded === normalized) break;
      normalized = decoded;
    } catch (error) {
      break;
    }
  }

  return normalized
    .replace(/\+\s*/g, " ")
    .replace(/\/\*[\s\S]*?\*\//g, " ")
    .replace(/\\/g, " ")
    .replace(/\s+/g, " ")
    .trim();
};

/**
 * 识别官网咨询表单中的明显 SQL 注入探测载荷。
 * 后端仍是最终防线，这里只用于提前给正常用户反馈。
 */
export const containsSqlInjectionProbe = (value) => {
  const normalized = normalize(value);
  return Boolean(normalized) && SQL_PROBE_PATTERNS.some((pattern) => pattern.test(normalized));
};
